<nav class="navbar navbar-light bg-light navbar-expand-lg">
    <form class="form-inline flex-fill" id="formularioFiltros">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <ul class="navbar-nav me-auto">
            <!--buscador -->
            <li class="nav-item ms-3">
                <div class="nav-item">
                    <input id="busquedaFormControl" type="text" class="form-control" placeholder="Buscador"
                      [formControl]="busquedaFormControl" (input)="filtrarMovimientos()" maxlength="16"/>
                    @if (solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho) {
                      <div *ngIf="busqueda?.invalid && busqueda?.errors.required
                          && (busqueda?.dirty || busqueda?.touched)" class="alert alert-danger">
                        N&uacute;mero requerido
                      </div>
                      <div *ngIf="busqueda?.invalid && busqueda?.errors.numeroRancho
                          && (busqueda?.dirty || busqueda?.touched)" class="alert alert-danger">
                        N&uacute;mero de rancho inv&aacute;lido
                      </div>
                    }
                </div>
            </li>
            @if (solapaRanchosDestino != TipoSolapaRancho.BucadorDeRancho) {
            <!--boton producto-->
              <li class="nav-item ms-2">
                  <div ngbDropdown autoClose="outside">
                      <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" id="dropdownProductos"
                          ngbDropdownToggle>Productos</button>
                      <div ngbDropdownMenu aria-labelledby="dropdownProductos">
                          <div class="px-4 py-3">
                              <div *ngFor="let prod of productosParaCheckear; let i = index">
                                  <div class="form-check">
                                      <input type="checkbox" name="productos+{{i}}" class="form-check-input"
                                          id="{{ 'dropdownCheck' + prod.nombre}}" [(ngModel)]="prod.seleccionado"
                                          (change)="filtrarMovimientos($event)">
                                      <label class="form-check-label text-nowrap" for="{{ 'dropdownCheck' + prod.nombre}}">
                                          {{prod.nombre}}
                                      </label>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </li>
            }
            @if (solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho) {
            <!-- fecha de vigencias (SOLO PARA RANCHOS CONSUMIDOS O BUSCADOR DE RANCHOS)-->
              @if (solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos) {
                <li class="nav-item ms-2">
                    <div style="align-items: center;" class="input-group">
                      @if (solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos)  {
                        <label class="me-2" >Vigente al</label>
                      }
                      @else {
                        <div ngbDropdown autoClose="outside">
                          <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" id="dropdownForm2" ngbDropdownToggle> Vigencias
                            al
                          </button>
                          <div ngbDropdownMenu aria-labelledby="dropdownForm2">
                            <div class="px-4 py-3">
                              <div *ngFor="let vigencia of vigencias">
                                <div class="form-check">
                                  <input type="checkbox" class="form-check-input" id="{{ 'dropdownCheck' + vigencia.nombre}}"
                                        [(ngModel)]="vigencia.seleccionado" name="{{vigencia.nombre}}">
                                  <label class="form-check-label text-nowrap" for="{{ 'dropdownCheck' + vigencia.nombre}}">
                                    {{ vigencia.nombre}}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                        <input type="date" [ngModel]="modelDesde" class="fechaFormControlDesdeHasta" placeholder="aaaa-mm-dd"
                            (ngModelChange)="modelDesde = $event" name="dt" ngbDatepicker #d="ngbDatepicker" value="model"
                            class="form-control form-control-rounded" #id="ngbDatepicker" #searchDate required readonly>

                        <div class="input-group-append">
                            <button id="botonDesde" type="button" class="input-group-btn btn btn-secondary" (click)="toggleDatepicker(d)">
                                <i class="fa fa-calendar" aria-hidden="true"></i></button>
                        </div>
                    </div>
                </li>
              }
              
              <li class="nav-item">
                <button class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" (click)="filtrarMovimientosPorFecha()"
                        [disabled]="solapaRanchosDestino === TipoSolapaRancho.BucadorDeRancho && busqueda?.invalid">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </button>
              </li>
            }

            @if (solapaRanchosDestino != TipoSolapaRancho.BucadorDeRancho) {
              <!--boton exportar excel (COMERCIAL)-->
              <li class="nav-item">
                  <button class="btn btn-outline-success my-2 my-lg-0 mx-lg-2" (click)="exportarListadoRanchosExcel()">
                      <i class="fa fa-file-excel-o p-1"></i>Exportar
                  </button>
              </li>
            }
            @if (solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho) {
              <li class="nav-item">
                  <div class="form-check" style="margin-left: 2em; margin-top: 0.5em;">
                      <input type="checkbox" class="form-check-input" name="mostrarDesactivadosFormControl"
                          id="mostrarDesactivadosFormControl" (change)="filtrarMovimientos()"
                          [(ngModel)]="this.mostrarDesactivado">
                      <label class="form-check-label" for="mostrarDesactivadosFormControl">Mostrar desactivados</label>
                  </div>
              </li>
            }
        </ul>
    </form>
</nav>


<ngb-alert [dismissible]="false" *ngIf="!obteniendoRanchos && ranchosFiltrados!=null && ranchosFiltrados.length==0">
      @if (solapaRanchosDestino != TipoSolapaRancho.BucadorDeRancho) {
        No existen movimientos para la busqueda seleccionada
      } @else {
        No existe el rancho solicitado
      }
    </ngb-alert>

<div class="">
    <form class="mb-3">
        <div class="col col-md-12">
            <div class="spinner-container" *ngIf="obteniendoRanchos">
                <ngx-spinner name="spinnerLista" bdOpacity=0.3bd
                    Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
                    <p style="color: white"> C a r g a n d o . . . </p>
                </ngx-spinner>
            </div>
            <div *ngIf="this.ranchos!=null"
                 id="scroll-infinito"
                 infinite-scroll
                 [infiniteScrollDistance]="distance"
                 [infiniteScrollThrottle]="throttle"
                 [scrollWindow]="false"
                 [infiniteScrollDisabled]="this.obteniendoRanchosScroll || this.stopScroll"
                 class="tabla-ranchos"
                 (scrolled)="onScrollRanchos(scrollActivo)">
                <table class="table table-sm table-striped" *ngIf="this.ranchos!=null && ranchosFiltrados.length > 0 && !obteniendoRanchos">
                  <thead class="text-center letra">
                    <th scope="col">Concatenado</th>
                    <th scope="col" *ngIf="solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho">Nro.Rancho</th>
                    <th scope="col">Cliente</th>
                    <th scope="col">Aeroplanta</th>
                    <th scope="col">Bandera</th>
                    <th scope="col">Destino</th>
                    <th scope="col">Producto</th>
                    <th scope="col">Volumen</th>
                    <th scope="col">F.Desde</th>
                    <th scope="col">F.Hasta</th>
                    <th scope="col">Moneda</th>
                    <th scope="col">Precio</th>
                    <th scope="col">Lote</th>
                    <th scope="col">Cta. Fact.</th>
                    <th scope="col">Se Factura</th>
                    <th scope="col">FOB</th>
                    <th scope="col">Comentarios</th>
                    <th scope="col" *ngIf="solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho">Adjuntos</th>
                    <th scope="col">Pa&iacute;s Facturaci&oacute;n</th>
                    <th scope="col" *ngIf="solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho">Acci&oacute;n</th>
                    <th scope="col">{{ (solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho) ? 'Saldo' : 'Acci&oacute;n' }} </th>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of ranchosFiltrados; let i=index" class="letra">
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center">{{r.concatenado}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" *ngIf="this.solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho">
                                {{r.codigoRancho}}
                      </td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.cliente.razonSocial}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center">{{r.aeroplanta.codigoAeroplanta}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center">{{r.codigoBandera}} - {{r.bandera}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.destino.nombre}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.producto.codigoProducto}} - {{ obtenerDescripcionProducto(r.producto.codigoProducto) }}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.volumen | number: '1.0-0'}} LTS</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.fechaInicio | date: "dd'/'MM'/'y"}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.fechaVencimiento | date: "dd'/'MM'/'y"}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.moneda}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.precio | number: "1.5-5"}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.numeroLote}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >{{r.ctA_ParaFacturar != "" ? r.ctA_ParaFacturar : "--"}}</td>
                      <td [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center" >
                        <i *ngIf="r.seFactura" class="fa fa-check-circle" aria-hidden="true"></i>
                        <div *ngIf="!r.seFactura">--</div>
                      </td>
                      <td  [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center">{{r.fob }}</td>
                      <td class="text-center">
                          @if (r.comentarios) {
                          <button
                            class="btn btn-sm"
                            [popoverTitle]="titulo"
                            [ngbPopover]="contenido">
                            <i ngbTooltip="Ver Comentarios" class="fa fa-eye" aria-hidden="true"></i>
                          </button>
                              <ng-template #titulo>Comentarios:</ng-template>
                              <ng-template #contenido>{{ r.comentarios }}</ng-template>
                            }
                            <div *ngIf="!r.comentarios">--</div>
                        </td>
                        <td *ngIf="solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho" class="text-center">
                            @if (r.archivosAdjuntos.length >=1) {
                                <button
                                    class="btn btn-sm"
                                    [popoverTitle]="titulo"
                                    [ngbPopover]="contenido"
                                    (click)="verAdjuntos(r.archivosAdjuntos)">
                                    <i ngbTooltip="Ver Adjuntos" class="fa fa-eye" aria-hidden="true"></i>
                                </button>
                            }
                            <div *ngIf="r.archivosAdjuntos.length === 0">--</div>
                        </td>
                        <td  [ngClass]="{'remarcar': r.estado==TipoEstado.Anulado }" class="text-center">
                            {{r.nombrePaisFacturacion }}
                        </td>
                        <td class="text-center" *ngIf="solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho">
                            <button
                                *ngIf="(solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos && r.estado==TipoEstado.Aprobado) ||
                                       (solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho && r.estado==TipoEstado.Aprobado)"
                          [disabled]="!this.hasRole(TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.APROBADORBYR)"
                          class="btn btn-sm btn-danger" (click)="desactivarRanchoPorRanchoID(r)">
                          <span class="fa fa-pencil" ngbTooltip="Desactivar Rancho"></span>
                        </button>
                      </td>
                      <td class="text-center">
                            <button *ngIf="solapaRanchosDestino == TipoSolapaRancho.SolicitudRancho"
                                class="btn btn-sm" [ngClass]="{'btn-success': r.volumen != r.volumenDisponible, 'btn-secondary': r.volumen == r.volumenDisponible}" (click)="asignarNumeroDeRancho(r)">
                          <i ngbTooltip="Asignar Numero de Rancho" class="fa fa-pencil" aria-hidden="true"></i>
                        </button>
                        <button
                              *ngIf="solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoSolicitados && r.estado==TipoEstado.Pendiente"
                          class="btn btn-sm" [ngClass]="{'btn-success': r.volumen != r.volumenDisponible, 'btn-secondary': r.volumen == r.volumenDisponible}" (click)="eliminarRanchoPorRanchoID(r)">
                          <span class="fa fa-trash" ngbTooltip="Eliminar Rancho"></span>
                        </button>
                        <button style="margin-left: -0.7em;" *ngIf="solapaRanchosDestino == TipoSolapaRancho.ListadoRanchoConsumidos || solapaRanchosDestino == TipoSolapaRancho.BucadorDeRancho"
                                class="btn btn-sm my-2 my-lg-0" [ngClass]="{'btn-success': r.volumen != r.volumenDisponible, 'btn-secondary': r.volumen == r.volumenDisponible}" (click)="verBitacoraRancho(r)">
                          {{r.volumenDisponible}}
                          <span class="fa fa-eye" ngbTooltip="Ver la bitacora"></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div style="justify-content: center;" *ngIf="this.obteniendoRanchosScroll" class="d-flex align-items-center text-primary">
                <div class="spinner-border" role="status"></div><span>Cargando mas datos..</span>
            </div>
        </div>
    </form>
</div>
